import React from 'react';
import { Link } from 'react-router-dom';

interface HeroSectionProps {
  title: string;
  titleProcessed: string;
  heroFeaturedImage?: string;
  heroSubtitle?: string;
  heroPrimaryBtnText?: string;
  heroPrimaryBtnUrl?: string;
  heroSecondaryBtnText?: string;
  heroSecondaryBtnUrl?: string;
  heroBadgeText?: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  titleProcessed,
  heroFeaturedImage,
  heroSubtitle,
  heroPrimaryBtnText = "Znajdź trenera",
  heroPrimaryBtnUrl = "/znajdz-trenera",
  heroSecondaryBtnText = "Zostań trenerem",
  heroSecondaryBtnUrl = "/dla-trenerow",
  heroBadgeText = "Trenerzy dostępni online"
}) => {
  return (
    <section className="landing-hero">
      <div className="landing-hero-container">
        <div className="landing-hero-content">
          <h1>{titleProcessed}</h1>
          {heroSubtitle && <p className="landing-hero-subtitle">{heroSubtitle}</p>}
          <div className="landing-hero-buttons">
            <Link
              to={heroPrimaryBtnUrl}
              className="landing-hero-btn-primary"
            >
              {heroPrimaryBtnText}
            </Link>
            <Link
              to={heroSecondaryBtnUrl}
              className="landing-hero-btn-secondary"
            >
              {heroSecondaryBtnText}
            </Link>
          </div>
        </div>

        {heroFeaturedImage && (
          <div className="landing-hero-image">
            <img
              src={heroFeaturedImage}
              alt={title}
              loading="lazy"
            />
            <div className="landing-hero-badge">
              <div className="landing-hero-badge-content">
                <div className="landing-hero-badge-dot"></div>
                <span className="landing-hero-badge-text">{heroBadgeText}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroSection;